import type { Stadium } from '@uefadigital/panenka';
import clsx from 'clsx';
import type { CSSProperties } from 'react';
import { memo } from 'react';

import { useTicketingOptions } from '../../../store';

import { hydrateWithTranslations } from '@services/TranslatorService';
import { competitionFolder, imgBaseUrl } from '@utilities/WindowContext';

import * as styles from './styles.module.scss';

type StadiumIconProps = {
  stadium: Stadium;
  isClickable?: boolean;
};

const StadiumIcon = ({ stadium, isClickable = false }: StadiumIconProps) => {
  const {
    options: { useCityIcons },
  } = useTicketingOptions();

  const path = useCityIcons ? 'cities' : 'stadiums';
  const venue = useCityIcons ? stadium.city : stadium;

  if (!venue) return null;

  return (
    <div
      style={
        {
          '--stadium-image': `url(${imgBaseUrl}/imgml/uefacom/${competitionFolder}/ticketing/${path}/${venue.id}.svg)`,
        } as CSSProperties
      }
      className={clsx(styles.stadiumImg, isClickable && styles.clickable)}
      title={hydrateWithTranslations(venue).name}
    />
  );
};

export default memo(StadiumIcon);
